import {stringify} from 'qs'
import {format} from 'utils'
import request from 'crm/utils/request'
import api from '../api/store-management'

export async function config() {
    return request(api.config.url)
}

export async function setConfig(payload) {
    return request(api.setConfig.url, {
        method: api.setConfig.type,
        body: payload.body,
    })
}

export async function groups() {
    return request(api.groups.url)
}

export async function stores(params) {
    return request(`${api.stores.url}${stringify(params, {addQueryPrefix: true})}`)
}

export async function storeChatGroups(payload) {
    return request(`${api.storeChatGroups.url}${stringify(payload.params, {addQueryPrefix: true})}`)
}

export async function sync() {
    return request(api.sync.url, {
        method: api.sync.type,
    })
}

export async function syncGroupCode() {
    return request(api.syncGroupCode.url, {
        method: api.syncGroupCode.type,
    })
}

export async function syncStatus(payload) {
    return request(format(api.syncStatus.url, {task_id: payload.id}))
}

export async function currentTree() {
    return request(api.currentTree.url, null, {
        checkMetaCode: false,
    })
}

export async function updateStoreGroupCode(payload) {
    return request(format(api.updateStoreGroupCode.url, {id: payload.id}), {
        method: api.updateStoreGroupCode.type,
    })
}

export async function storeDrainageUsers(payload) {
    return request(format(api.storeDrainageUsers.url, {id: payload.id}))
}

export async function downloadTemplate() {
    // 加时间戳参数，防止浏览器缓存
    return request(`${api.downloadTemplate.url}?t=${new Date().getTime()}`, null, {
        returnResponse: true,
    })
}

export async function importGroupLink(payload) {
    return request(api.importGroupLink.url, {
        method: api.importGroupLink.type,
        body: payload.body,
    })
}

export async function updateFullUsers(payload) {
    return request(api.updateFullUsers.url, {
        method: api.updateFullUsers.type,
        body: payload.body,
    })
}

export async function downloadFullUsers() {
    return request(`${api.downloadFullUsers.url}?t=${new Date().getTime()}`, null, {
        returnResponse: true,
    })
}
